export * from './symbols';
import and from './and';
import constant from './constant';
import compose from './compose';
import create from './create';
import curry from './curry';
import curryN from './curryN';
import curryR from './curryR';
import defaultTo from './defaultTo';
import getName from './getName';
import identity from './identity';
import ifElse from './ifElse';
import isNothing from './isNothing';
import neg from './neg';
import not from './not';
import noop from './noop';
import or from './or';

import setName from './setName';
import swap from './swap';
import thunk from './thunk';
import toString from './toString';
import unless from './unless';
import when from './when';
const T=constant(true);
const F=constant(false);

export interface IPredicate {
    (a): boolean;
}

const notPredicate=(predicate:IPredicate):IPredicate=>(a)=>not(predicate(a));

export {
    and,
    constant,
    compose,
    create,
    curry,
    curryN,
    curryR,
    defaultTo,
    getName,
    identity,
    ifElse,
    isNothing,
    neg,
    not,
    noop,
    notPredicate,
    or,
    setName,
    thunk,
    swap,
    toString,
    unless,
    when,
    T,
    F


};




// WEBPACK FOOTER //
// ./src/index.ts